import type { RequestConfig } from "@app/config/axios/http";
import { storePlacesServices, type StorePlaceRemainder } from "../../../../../api/storePlaces";

/**
 * Загружает уникальные ячейки с положительным остатком партии. \
 * Источник: `stock/storePlaces.loadRemaindersByFilter`
 * (`LotCodes` + `InContextOfLot` + `OnlyPositiveRemainders`, без `DivisionCode` —
 * склад-отправитель уже закодирован в партии; `DivisionCode` контейнера — это потребитель).
 * @param lotCode код партии
 * @param config опции HTTP-запроса
 */
export async function resolveStockKanbanSupplyLotCells(
    lotCode: number,
    config?: RequestConfig,
): Promise<StorePlaceRemainder[]> {
    if (!isValidCode(lotCode)) {
        throw new Error(`Не удалось загрузить ячейки партии: некорректный код партии (${lotCode}).`);
    }

    const remainders = await storePlacesServices.remainders.load(
        {
            filter: {
                LotCodes: [lotCode],
                OnlyPositiveRemainders: true,
                InContextOfLot: true,
            },
            include: ["StorePlace"],
        },
        config,
    );

    return uniqueRemaindersBySpCode(remainders);
}

/**
 * Оставляет по одному остатку на уникальный `SpCode` (положительный, `SpCode !== 0`).
 * @param remainders остатки партии по ячейкам
 */
export function uniqueRemaindersBySpCode(remainders: StorePlaceRemainder[]): StorePlaceRemainder[] {
    const result: StorePlaceRemainder[] = [];
    const seenSpCodes = new Set<number>();

    remainders.forEach((remainder) => {
        if (!isValidCode(remainder.SpCode) || remainder.Qty <= 0 || seenSpCodes.has(remainder.SpCode)) {
            return;
        }

        seenSpCodes.add(remainder.SpCode);
        result.push(remainder);
    });

    return result;
}

function isValidCode(code: number): boolean {
    return code !== 0;
}
